import home from './moduls/home'
export default {
  home
}
